import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) {
  const M = motion[as];
  return (
    <M
      {...rest}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </M>
  );
}

// Masked line-by-line reveal. lines: array of strings or nodes.
export function MaskLines({ lines, as = "h2", className = "", delay = 0, onLoad = false, stagger = 0.09 }) {
  const Tag = as;
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.div {...trigger}>
      <Tag className={className}>
        {lines.map((line, i) => (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className="block"
              variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
              transition={{ duration: 1.05, ease, delay: delay + i * stagger }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </Tag>
    </motion.div>
  );
}

export function Clip({ children, className = "", delay = 0 }) {
  return (
    <motion.div
      className={className}
      initial={{ clipPath: "inset(12% 8% 12% 8%)", opacity: 0.4 }}
      whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1.3, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export { ease };
